module.exports = __webpack_public_path__ + "6227-shadow.a42406fae637877aa19825bb135c9f74.cache.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/6227-shadow.png
// module id = 484
// module chunks = 0